import {UPDATE_BANNER_ERROR, UPDATE_BANNER_START, UPDATE_BANNER_SUCCESS} from "../../types";

export default function update_banner(state, action) {
    switch (action.type) {
        case UPDATE_BANNER_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_BANNER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case UPDATE_BANNER_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
